
<template>
  <div id="myApp">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive">
          <!-- 这里是会被缓存的视图组件，比如 Home！ -->
        </router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'MyView',
    components: {
    },
    data() {
      return {
      }
    },
    mounted () {
    }

  }
</script>

<style>
  #myApp{
    height: 100%;
  }
</style>
